// src/features/landing/presentation/components/RbBridgeConsultSection.jsx
// RB 브릿지 페이지(/rb-bridge) 표지 아래 상담 신청 — 매수자 · 매도자 · 파트너스 박스 3개.
// 박스를 누르면 신청 페이지(/rb-bridge/consult/:slug, RbBridgeConsultPage)로 이동한다. (2026-10-02 모달 → 페이지로 변경)
// 하단 "비공개 상담 신청"은 글자 링크가 아니라 버튼으로 보이게 한다(박스 전체가 링크라 실제 요소는 span, 2026-10-10).
import React from "react";
import { Link } from "react-router-dom";
import { RB_BRIDGE_CONSULT_TYPES } from "../../domain/rbBridgeConsult";

export function RbBridgeConsultSection() {
    // utm_* 쿼리를 신청 페이지까지 이어 붙여 유입 경로를 잃지 않게 한다
    const search = typeof window !== "undefined" ? window.location.search : "";

    return (
        <section id="consult" className="rbc" aria-labelledby="rbc-heading">
            <div className="rbc-head">
                <div>
                    <p className="rbc-eyebrow">Private Consultation</p>
                    <h2 id="rbc-heading" className="rbc-heading">회사를 드러내지 않고, <br />비공개 상담부터 시작하세요.</h2>
                </div>
                <p className="rbc-sub">조직명·실명 없이 연락처만으로 신청하실 수 있습니다. <br />상담만으로 등록되지 않으며, 동의 없이 어떤 정보도 공개되지 않습니다.</p>
            </div>
            <div className="rbc-boxes">
                {RB_BRIDGE_CONSULT_TYPES.map((c) => (
                    <Link key={c.type} to={`/rb-bridge/consult/${c.slug}${search}`} className={`rbc-box rbc-box--${c.tone}`}>
                        <span className={`rbc-box-en rbc-tone-text--${c.tone}`}>{c.en}</span>
                        <span className="rbc-box-label">{c.label}</span>
                        <span className="rbc-box-title">{c.title}</span>
                        <span className="rbc-box-body">{c.body}</span>
                        <span className="rbc-box-cta">비공개 상담 신청 <span aria-hidden="true">→</span></span>
                    </Link>
                ))}
            </div>

            <style jsx>{`
                .rbc { scroll-margin-top: 140px; }
                .rbc-head { display: flex; justify-content: space-between; align-items: flex-end; gap: 24px; margin-bottom: 32px; }
                .rbc-eyebrow { margin: 0 0 10px; font-size: 13px; font-weight: 700; letter-spacing: 0.08em; text-transform: uppercase; color: #c2926b; }
                .rbc-heading { margin: 0; font-size: clamp(26px, 3vw, 34px); line-height: 1.3; font-weight: 800; letter-spacing: -0.02em; color: #1c1814; }
                .rbc-sub { margin: 0; font-size: 14px; line-height: 1.7; color: #8a8079; text-align: right; }
                .rbc-boxes { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 16px; }
                .rbc-box {
                    display: flex; flex-direction: column; align-items: flex-start; gap: 8px;
                    padding: 28px 28px 24px; text-align: left; cursor: pointer; font: inherit; text-decoration: none;
                    background: #fff; border: 1px solid #e5ddd7; border-top: 3px solid #f16102; border-radius: 12px;
                    box-shadow: 0 2px 10px rgba(28, 24, 20, 0.04);
                    transition: background 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
                }
                .rbc-box--brown { border-top-color: #c2926b; }
                .rbc-box--ink { border-top-color: #1c1814; }
                .rbc-box:hover { box-shadow: 0 10px 28px rgba(28, 24, 20, 0.08); transform: translateY(-2px); }
                .rbc-box:focus-visible { outline: 2px solid #f16102; outline-offset: 2px; }
                .rbc-tone-text--orange { color: #f16102; }
                .rbc-tone-text--brown { color: #b07d55; }
                .rbc-tone-text--ink { color: #1c1814; }
                .rbc-box-en { font-size: 12px; font-weight: 800; letter-spacing: 0.06em; text-transform: uppercase; }
                .rbc-box-label { font-size: 22px; font-weight: 800; color: #1c1814; }
                .rbc-box-title { font-size: 15px; font-weight: 700; color: #1c1814; }
                .rbc-box-body { font-size: 14px; line-height: 1.7; color: #4a433d; }
                .rbc-box-cta {
                    display: inline-flex; align-items: center; gap: 8px; margin-top: auto;
                    padding: 12px 20px; border-radius: 8px; background: #f16102; color: #fff;
                    font-size: 15px; font-weight: 700; transition: background 0.2s ease;
                }
                .rbc-box-body { margin-bottom: 12px; }
                .rbc-box:hover .rbc-box-cta { background: #d95502; }


                @media (max-width: 1024px) {
                    .rbc-boxes { grid-template-columns: minmax(0, 1fr); }
                    .rbc-box { padding: 22px 20px 20px; }
                }
                @media (max-width: 768px) {
                    .rbc-head { flex-direction: column; align-items: flex-start; gap: 8px; margin-bottom: 24px; }
                    .rbc-sub { text-align: left; }
                    .rbc-sub br, .rbc-heading br { display: none; }
                    .rbc-box-label { font-size: 20px; }
                    .rbc-box-cta { align-self: stretch; justify-content: center; }
                }
            `}</style>
        </section>
    );
}
